import { render, staticRenderFns } from "./ContactMoneyPayments.vue?vue&type=template&id=049d25e6&scoped=true"
import script from "./ContactMoneyPayments.vue?vue&type=script&lang=js"
export * from "./ContactMoneyPayments.vue?vue&type=script&lang=js"
import style0 from "./ContactMoneyPayments.vue?vue&type=style&index=0&id=049d25e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d25e6",
  null
  
)

export default component.exports